import React from "react";
import { ErrorNavigationContext } from "../ErrorNavigationContext";

export function useErrorNavigationState() {
  return React.useContext(ErrorNavigationContext).state;
}
